// extracted by mini-css-extract-plugin
export var cardHeader = "_gg-0";
export var reorderHandle = "_gg-3";
export var titleArea = "_gg-1";
export var titleAreaWithHandle = "_gg-2";